import { render, staticRenderFns } from "./SupportTicketNew.vue?vue&type=template&id=37dc5046&scoped=true&"
import script from "./SupportTicketNew.vue?vue&type=script&lang=js&"
export * from "./SupportTicketNew.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketNew.vue?vue&type=style&index=0&id=37dc5046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc5046",
  null
  
)

export default component.exports